module.exports = __webpack_public_path__ + "static/media/aniversario-gray-icon.4c17274a.svg";